import styled from "styled-components";
import banner from "./banerWielkanoc.png";
import { ReactComponent as ListItemTag } from "./listItem.svg";

export const StyledHeaderBar = styled.div`
  background-image: url(${banner});
  background-size: cover;
  margin: 0;
  padding: 5px;
  min-height: 154px;
  height: auto;
  display: grid;
  grid-column: span 2;
  font-family: "Oswald", sans-serif;
  align-items: end;

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    grid-column: span 1;
    min-height: 80px;
  }
`;

export const FirstPartHeader = styled.div`
  font-size: 30px;
  color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 20px;
  }
`;

export const SecondPartHeader = styled.div`
  font-size: 30px;
  color: ${({ theme }) => theme.colors.pink};

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 20px;
  }
`;

export const ListItemContainer = styled.div`
  margin: 1px 10px;
  display: flex;
`;

export const StyledListItemTag = styled(ListItemTag)`
  width: 23px;
`;

export const HeaderMainContent = styled.div`
  font-size: 17px;
  padding: 0 20px;
  text-align: center;
  align-self: center;
  color: ${({ theme }) => theme.colors.white};

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 13px;
  }
`;

export const Header = styled.h1`
  display: flex;
  gap: 3px;
  margin: 10px;

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 13px;
  }
`;

export const FeaturesList = styled.ul`
  font-size: 13px;
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.white};
  list-style: none;
  display: grid;
  gap: 20px;
  grid-template-columns: auto auto 1fr;

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 11px;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.mobileMax}) {
    display: none;
  }
`;

export const ListItem = styled.li`
  padding: 5px;
`;

export const SpecificListItem = styled.li`
  color: ${({ theme }) => theme.colors.pink};
  padding: 10px 80px;
  font-size: 18px;

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    grid-template-columns: auto 1fr;
    font-size: 9px;
  }
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.white};
  font-size: 13px;
  text-align: center;
  text-decoration: underline;
  transition: color 0.2s ease;
  border: 1px;
  border-radius: 30px;
  padding: 5px;
  background-color: #dd00a4;
  text-decoration: none;

  &:hover {
    cursor: pointer;
    background-color: #ff26c7;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 9px;
    padding: 3px;
  }
`;

export const LinkWrapper = styled.span`
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  max-width: 150px;
  display: grid;
  margin: 20px;
  text-align: center;
  text-decoration: none;

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    max-width: 90px;
  }
`;
